import React from 'react';
import { ActionButtons, Box, styled } from 'bumbag';

import { TOUCH_MAX_BREAKPOINT } from '../../constants';
const Wrapper = styled(Box)`
  @media screen and (max-width: ${TOUCH_MAX_BREAKPOINT}px) {
    && > div {
      display: flex;
    }
    && button {
      font-size: 1.25rem;
      flex: 1;
      height: 50px;
    }
  }
`;
export default function SubmitCancelButtons(props: Record<string, any>) {
  const { isLoading } = props;
  let newProps = props;
  if (isLoading) {
    newProps = {
      ...props,
      submitProps: { ...props.submitProps, disabled: true },
      cancelProps: { ...props.cancelProps, disabled: true },
    };
  }
  return (
    <Wrapper>
      <ActionButtons palette="secondary" {...newProps} />
    </Wrapper>
  );
}
